import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga";

const usePageTracking = (gaTrackingId) => {
	const location = useLocation();

	useEffect(() => {
		ReactGA.initialize(gaTrackingId);
		ReactGA.pageview(location.pathname + location.search);
	}, [location]);
};

export default usePageTracking;
